/*
 * @Author: ZS
 * @Date: 2020-06-17 08:52:40
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-07 15:41:40
 * @Description: file content
 */
import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'

axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      if (response.data.status === 200) {
        return Promise.resolve(response.data);
      } else if (response.data.status === 530) {
        console.log('登录后才能访问')
        return Promise.resolve(response.data);
      } else if (response.data.status === 403) {
        console.log('无权限')
      } else if (response.data.status === 400) {
        console.log('参数异常')
      } else if (response.data.status === 4011) {
        console.log('登陆失败账户不存在')
      } else if (response.data.status == 5301) {
        console.log('未登录')
        return Promise.resolve(response.data);
      } else if (response.data.status == -1) {
        console.log('系统异常')
      }
      return Promise.resolve(response.data || response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    // if (error.response.status) {
    //   switch (error.response.status) {
    //     // 401: 未登录
    //     // 未登录则跳转登录页面，并携带当前页面的路径
    //     // 在登录成功后返回当前页面，这一步需要在登录页操作。
    //     case 401:
    //       // alert("身份验证失败，请关闭重新进入。");
    //       break;

    //       // 403 token过期
    //       // 登录过期对用户进行提示
    //       // 清除本地token和清空vuex中token对象
    //       // 跳转登录页面
    //     case 403:
    //       // alert("登录过期，请关闭重新进入。");
    //       // 清除token
    //       break;

    //       // 404请求不存在
    //     case 404:
    //       // alert("您访问的网页不存在。");
    //       break;
    //       // 其他错误，直接抛出错误提示
    //     default:
    //       // alert(error.response.data.message);
    //   }
    //   return Promise.reject(error.response);
    // }
  }
);
export const ywtbRequest = (url, params) => {
  return axios({
    method: 'POST',
    url: `${url}`,
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export const ywtbRequestGet = (url, params) => {
  return axios({
    method: 'GET',
    url: `${url}`,
    params: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export const ywtbRequestGetDown = (url, params) => {
  return axios({
    method: 'GET',
    url: `${url}`,
    params: params,
    responseType: 'blob',
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export const request = (param) => {
  const _ = new Date().getTime()
  if (param.params) {
    Object.assign(param.params, {
      _: _
    })
  } else {
    Object.assign(param, {
      params: {
        _: _
      }
    })
  }
  if (param.nativeForm) {
    param.headers = {
      ...param.headers,
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }
  return new Promise((resolve, reject) => {
    axios(param).then((res) => {
      if (res.status === 200) {
        return resolve(res)
      } else {
        Message({
          message: res.msg || 'Error',
          type: 'warning',
          duration: 5 * 1000
        })
        return reject(res)
      }
    }).catch((err) => { reject(err) })
  })
}



// WEBPACK FOOTER //
// ./src/api/axios.js